//import { getLanguage } from "./Language";
import { debugSettings } from '_debug';
export class Ajax {
    // public static async get(url: string): Promise<any> {
    //     const text = await this.getRaw(url);
    //     return text ? JSON.parse(text) : undefined;
    // }
    static async get(url) {
        const text = await this.getRaw(url);
        return text ? JSON.parse(text) : undefined;
    }
    static async getRaw(url) {
        return await this.doFetchRaw(url, 'GET');
    }
    static async post(url, data) {
        const body = data && JSON.stringify(data);
        const text = await this.postRaw(url, body);
        return text ? JSON.parse(text) : undefined;
    }
    static async put(url, data) {
        const body = data && JSON.stringify(data);
        const text = await this.doFetchRaw(url, 'PUT', body);
        return text ? JSON.parse(text) : undefined;
    }
    static async postRaw(url, data) {
        return this.doFetchRaw(url, 'POST', data);
    }
    static async doFetchRaw(url, method, body) {
        try {
            const response = await fetch(debugSettings.apiRoot + url, {
                method: method,
                mode: 'same-origin',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    //"Lng": getLanguage()
                },
                credentials: 'same-origin',
                body: body,
            });
            if (response.ok) {
                const appVersion = response.headers.get('App-Version');
                if (appVersion) {
                    document.appVersion = appVersion;
                }
                return await response.text();
            }
            else {
                let detail = await response.text();
                const error = new Error('Request failed');
                if (detail.startsWith('{')) {
                    detail = JSON.parse(detail);
                }
                error.status = response.status;
                error.detail = detail;
                return Promise.reject(error);
            }
        }
        catch (error) {
            console.error(error, debugSettings.apiRoot + url);
            return Promise.reject(new Error('Request failed'));
        }
    }
}
